// extracted by mini-css-extract-plugin
module.exports = {"container":"signin_container__1ov3t","bg":"signin_bg__f8BNi","logo":"signin_logo__8ozEI","or":"signin_or__25HKp","socialLogin":"signin_socialLogin__24Ylt"};